

























































import { defineComponent, ref } from '@vue/composition-api';
import { get } from 'lodash-es';
import { Message } from 'byted-vui';
import { i18n } from '@tt4b/ttam-i18n';
import { KEYWORDS_TEMPLATE_DOWNLOAD_URL } from '../const';

const name = 'ttam-search-keywords-upload';
export default defineComponent({
  name,
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    maxInputNumber: {
      type: Number,
      default: 1000,
    },
  },
  setup(props, { emit }) {
    const keywordsData = ref<string[]>([]);
    const fileList = ref<File[]>([]);
    const keywordsTemplateDownLoadUrl = ref(KEYWORDS_TEMPLATE_DOWNLOAD_URL);

    async function analysisExcel(file: File) {
      const { read, utils } = await import(/* webpackChunkName: "xlsx" */ 'xlsx');

      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = function (e) {
          const target = e.target as FileReader;
          const data = target.result;
          const datajson = read(data, {
            type: 'binary',
          });

          const result = datajson.SheetNames.map(sheetName => ({
            sheetName,
            sheet: utils.sheet_to_json(datajson.Sheets[sheetName], {
              range: -1,
            }),
          }));

          resolve(result);
        };
        reader.readAsBinaryString(file);
      });
    }

    function resetUploadData() {
      fileList.value = [];
      keywordsData.value = [];
    }

    async function handleUploadData(rawFile: File): Promise<void> {
      if (Math.floor(rawFile.size) >= 1024 * 500) {
        Message.error(i18n.t('adgroup_search_keywords_upload_file_oversize_tip') as string);
        resetUploadData();
        return;
      }

      const resData = await analysisExcel(rawFile);
      const sheet = get(resData, [0, 'sheet'], []);
      const list = sheet.map(item => Object.values(item)[0]?.toString()) as string[];

      /** 不需要列名 */
      keywordsData.value = list.slice(1);
    }

    function onUploadChange(file, files, rawFile: File) {
      handleUploadData(rawFile);
    }

    function onUploadExceed(files: File[]) {
      /** 同一时刻仅允许上传一个文件，如果再上传则覆盖
       * 1. 更新文件信息列表
       * 2. 重新上传
       */
      const currentFile = files[0];
      resetUploadData();

      fileList.value = [currentFile];
      handleUploadData(currentFile);
    }

    function onUploadRemove() {
      resetUploadData();
    }

    function onClose() {
      resetUploadData();

      emit('on-upload-dialog-close');
    }

    function onCancelClick() {
      resetUploadData();

      emit('on-upload-dialog-close');
    }

    function onConfirmClick() {
      emit('on-upload-keywords', keywordsData.value);

      resetUploadData();

      emit('on-upload-dialog-close');
    }

    return {
      name,
      keywordsData,
      fileList,
      keywordsTemplateDownLoadUrl,
      onClose,
      onUploadChange,
      onCancelClick,
      onConfirmClick,
      onUploadExceed,
      onUploadRemove,
    };
  },
});
